import React, { Fragment, PureComponent } from 'react'
import {
  Typography,
  IconButton,
  Popover,
} from '@material-ui/core'
import { Today } from '@material-ui/icons'

import { Calendar } from 'components'

const popoverOptions = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  }
}

export class DatePickerBase extends PureComponent {
  state = {
    anchorEl: null
  }

  showPopover = e => this.setState({ anchorEl: e.currentTarget })

  closePopover = () => this.setState({ anchorEl: null })

  render() {
    const { anchorEl } = this.state
    const { year, monthLabel, selectDate, isPricesPage, selectRangeDate } = this.props

    return (
      <Fragment>

        {!isPricesPage && (
          <Typography color='inherit' variant='subtitle1'>
            {monthLabel} {year}
          </Typography>
        )}

        <IconButton color='inherit' onClick={this.showPopover}>
          <Today />
        </IconButton>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.closePopover}
          PaperProps={{
            style: { maxWidth: 300 }
          }}
          {...popoverOptions}
        >
          <Calendar 
            view='year' 
            selectRange={isPricesPage}
            maxDetail={isPricesPage ? 'month' : 'year'} 
            onChange={isPricesPage ? selectRangeDate : selectDate}
          />
        </Popover>
        
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePicker.js